export const countryOptions = [
    { label: "🌍 Worldwide", value: "Worldwide", code: "ALL", flag: "🌍" },
    { label: "🇦🇫 Afghanistan", value: "Afghanistan", code: "AF", flag: "🇦🇫" },
    { label: "🇦🇱 Albania", value: "Albania", code: "AL", flag: "🇦🇱" },
    { label: "🇩🇿 Algeria", value: "Algeria", code: "DZ", flag: "🇩🇿" },
    { label: "🇦🇩 Andorra", value: "Andorra", code: "AD", flag: "🇦🇩" },
    { label: "🇦🇴 Angola", value: "Angola", code: "AO", flag: "🇦🇴" },
    { label: "🇦🇬 Antigua and Barbuda", value: "Antigua and Barbuda", code: "AG", flag: "🇦🇬" },
    { label: "🇦🇷 Argentina", value: "Argentina", code: "AR", flag: "🇦🇷" },
    { label: "🇦🇲 Armenia", value: "Armenia", code: "AM", flag: "🇦🇲" },
    { label: "🇦🇺 Australia", value: "Australia", code: "AU", flag: "🇦🇺" },
    { label: "🇦🇹 Austria", value: "Austria", code: "AT", flag: "🇦🇹" },
    { label: "🇦🇿 Azerbaijan", value: "Azerbaijan", code: "AZ", flag: "🇦🇿" },
    { label: "🇧🇸 Bahamas", value: "Bahamas", code: "BS", flag: "🇧🇸" },
    { label: "🇧🇭 Bahrain", value: "Bahrain", code: "BH", flag: "🇧🇭" },
    { label: "🇧🇩 Bangladesh", value: "Bangladesh", code: "BD", flag: "🇧🇩" },
    { label: "🇧🇧 Barbados", value: "Barbados", code: "BB", flag: "🇧🇧" },
    { label: "🇧🇾 Belarus", value: "Belarus", code: "BY", flag: "🇧🇾" },
    { label: "🇧🇪 Belgium", value: "Belgium", code: "BE", flag: "🇧🇪" },
    { label: "🇧🇿 Belize", value: "Belize", code: "BZ", flag: "🇧🇿" },
    { label: "🇧🇯 Benin", value: "Benin", code: "BJ", flag: "🇧🇯" },
    { label: "🇧🇹 Bhutan", value: "Bhutan", code: "BT", flag: "🇧🇹" },
    { label: "🇧🇴 Bolivia", value: "Bolivia", code: "BO", flag: "🇧🇴" },
    { label: "🇧🇦 Bosnia and Herzegovina", value: "Bosnia and Herzegovina", code: "BA", flag: "🇧🇦" },
    { label: "🇧🇼 Botswana", value: "Botswana", code: "BW", flag: "🇧🇼" },
    { label: "🇧🇷 Brazil", value: "Brazil", code: "BR", flag: "🇧🇷" },
    { label: "🇧🇳 Brunei", value: "Brunei", code: "BN", flag: "🇧🇳" },
    { label: "🇧🇬 Bulgaria", value: "Bulgaria", code: "BG", flag: "🇧🇬" },
    { label: "🇧🇫 Burkina Faso", value: "Burkina Faso", code: "BF", flag: "🇧🇫" },
    { label: "🇧🇮 Burundi", value: "Burundi", code: "BI", flag: "🇧🇮" },
    { label: "🇰🇭 Cambodia", value: "Cambodia", code: "KH", flag: "🇰🇭" },
    { label: "🇨🇲 Cameroon", value: "Cameroon", code: "CM", flag: "🇨🇲" },
    { label: "🇨🇦 Canada", value: "Canada", code: "CA", flag: "🇨🇦" },
    { label: "🇨🇻 Cabo Verde", value: "Cabo Verde", code: "CV", flag: "🇨🇻" },
    { label: "🇨🇫 Central African Republic", value: "Central African Republic", code: "CF", flag: "🇨🇫" },
    { label: "🇹🇩 Chad", value: "Chad", code: "TD", flag: "🇹🇩" },
    { label: "🇨🇱 Chile", value: "Chile", code: "CL", flag: "🇨🇱" },
    { label: "🇨🇳 China", value: "China", code: "CN", flag: "🇨🇳" },
    { label: "🇨🇴 Colombia", value: "Colombia", code: "CO", flag: "🇨🇴" },
    { label: "🇰🇲 Comoros", value: "Comoros", code: "KM", flag: "🇰🇲" },
    { label: "🇨🇷 Costa Rica", value: "Costa Rica", code: "CR", flag: "🇨🇷" },
    { label: "🇭🇷 Croatia", value: "Croatia", code: "HR", flag: "🇭🇷" },
    { label: "🇨🇺 Cuba", value: "Cuba", code: "CU", flag: "🇨🇺" },
    { label: "🇨🇾 Cyprus", value: "Cyprus", code: "CY", flag: "🇨🇾" },
    { label: "🇨🇿 Czechia", value: "Czechia", code: "CZ", flag: "🇨🇿" },
    { label: "🇩🇰 Denmark", value: "Denmark", code: "DK", flag: "🇩🇰" },
    { label: "🇩🇯 Djibouti", value: "Djibouti", code: "DJ", flag: "🇩🇯" },
    { label: "🇩🇲 Dominica", value: "Dominica", code: "DM", flag: "🇩🇲" },
    { label: "🇩🇴 Dominican Republic", value: "Dominican Republic", code: "DO", flag: "🇩🇴" },
    { label: "🇪🇨 Ecuador", value: "Ecuador", code: "EC", flag: "🇪🇨" },
    { label: "🇪🇬 Egypt", value: "Egypt", code: "EG", flag: "🇪🇬" },
    { label: "🇸🇻 El Salvador", value: "El Salvador", code: "SV", flag: "🇸🇻" },
    { label: "🇬🇶 Equatorial Guinea", value: "Equatorial Guinea", code: "GQ", flag: "🇬🇶" },
    { label: "🇪🇷 Eritrea", value: "Eritrea", code: "ER", flag: "🇪🇷" },
    { label: "🇪🇪 Estonia", value: "Estonia", code: "EE", flag: "🇪🇪" },
    { label: "🇪🇹 Ethiopia", value: "Ethiopia", code: "ET", flag: "🇪🇹" },
    { label: "🇫🇯 Fiji", value: "Fiji", code: "FJ", flag: "🇫🇯" },
    { label: "🇫🇮 Finland", value: "Finland", code: "FI", flag: "🇫🇮" },
    { label: "🇫🇷 France", value: "France", code: "FR", flag: "🇫🇷" },
    { label: "🇬🇦 Gabon", value: "Gabon", code: "GA", flag: "🇬🇦" },
    { label: "🇬🇲 Gambia", value: "Gambia", code: "GM", flag: "🇬🇲" },
    { label: "🇬🇪 Georgia", value: "Georgia", code: "GE", flag: "🇬🇪" },
    { label: "🇩🇪 Germany", value: "Germany", code: "DE", flag: "🇩🇪" },
    { label: "🇬🇭 Ghana", value: "Ghana", code: "GH", flag: "🇬🇭" },
    { label: "🇬🇷 Greece", value: "Greece", code: "GR", flag: "🇬🇷" },
    { label: "🇬🇩 Grenada", value: "Grenada", code: "GD", flag: "🇬🇩" },
    { label: "🇬🇹 Guatemala", value: "Guatemala", code: "GT", flag: "🇬🇹" },
    { label: "🇬🇳 Guinea", value: "Guinea", code: "GN", flag: "🇬🇳" },
    { label: "🇬🇼 Guinea-Bissau", value: "Guinea-Bissau", code: "GW", flag: "🇬🇼" },
    { label: "🇬🇾 Guyana", value: "Guyana", code: "GY", flag: "🇬🇾" },
    { label: "🇭🇹 Haiti", value: "Haiti", code: "HT", flag: "🇭🇹" },
    { label: "🇭🇳 Honduras", value: "Honduras", code: "HN", flag: "🇭🇳" },
    { label: "🇭🇺 Hungary", value: "Hungary", code: "HU", flag: "🇭🇺" },
    { label: "🇮🇸 Iceland", value: "Iceland", code: "IS", flag: "🇮🇸" },
    { label: "🇮🇳 India", value: "India", code: "IN", flag: "🇮🇳" },
    { label: "🇮🇩 Indonesia", value: "Indonesia", code: "ID", flag: "🇮🇩" },
    { label: "🇮🇷 Iran", value: "Iran", code: "IR", flag: "🇮🇷" },
    { label: "🇮🇶 Iraq", value: "Iraq", code: "IQ", flag: "🇮🇶" },
    { label: "🇮🇪 Ireland", value: "Ireland", code: "IE", flag: "🇮🇪" },
    { label: "🇮🇱 Israel", value: "Israel", code: "IL", flag: "🇮🇱" },
    { label: "🇮🇹 Italy", value: "Italy", code: "IT", flag: "🇮🇹" },
    { label: "🇯🇲 Jamaica", value: "Jamaica", code: "JM", flag: "🇯🇲" },
    { label: "🇯🇵 Japan", value: "Japan", code: "JP", flag: "🇯🇵" },
    { label: "🇯🇴 Jordan", value: "Jordan", code: "JO", flag: "🇯🇴" },
    { label: "🇰🇿 Kazakhstan", value: "Kazakhstan", code: "KZ", flag: "🇰🇿" },
    { label: "🇰🇪 Kenya", value: "Kenya", code: "KE", flag: "🇰🇪" },
    { label: "🇰🇮 Kiribati", value: "Kiribati", code: "KI", flag: "🇰🇮" },
    { label: "🇰🇼 Kuwait", value: "Kuwait", code: "KW", flag: "🇰🇼" },
    { label: "🇰🇬 Kyrgyzstan", value: "Kyrgyzstan", code: "KG", flag: "🇰🇬" },
    { label: "🇱🇦 Laos", value: "Laos", code: "LA", flag: "🇱🇦" },
    { label: "🇱🇻 Latvia", value: "Latvia", code: "LV", flag: "🇱🇻" },
    { label: "🇱🇧 Lebanon", value: "Lebanon", code: "LB", flag: "🇱🇧" },
    { label: "🇱🇸 Lesotho", value: "Lesotho", code: "LS", flag: "🇱🇸" },
    { label: "🇱🇷 Liberia", value: "Liberia", code: "LR", flag: "🇱🇷" },
    { label: "🇱🇾 Libya", value: "Libya", code: "LY", flag: "🇱🇾" },
    { label: "🇱🇮 Liechtenstein", value: "Liechtenstein", code: "LI", flag: "🇱🇮" },
    { label: "🇱🇹 Lithuania", value: "Lithuania", code: "LT", flag: "🇱🇹" },
    { label: "🇱🇺 Luxembourg", value: "Luxembourg", code: "LU", flag: "🇱🇺" },
    { label: "🇲🇰 North Macedonia", value: "North Macedonia", code: "MK", flag: "🇲🇰" },
    { label: "🇲🇬 Madagascar", value: "Madagascar", code: "MG", flag: "🇲🇬" },
    { label: "🇲🇼 Malawi", value: "Malawi", code: "MW", flag: "🇲🇼" },
    { label: "🇲🇾 Malaysia", value: "Malaysia", code: "MY", flag: "🇲🇾" },
    { label: "🇲🇻 Maldives", value: "Maldives", code: "MV", flag: "🇲🇻" },
    { label: "🇲🇱 Mali", value: "Mali", code: "ML", flag: "🇲🇱" },
    { label: "🇲🇹 Malta", value: "Malta", code: "MT", flag: "🇲🇹" },
    { label: "🇲🇭 Marshall Islands", value: "Marshall Islands", code: "MH", flag: "🇲🇭" },
    { label: "🇲🇷 Mauritania", value: "Mauritania", code: "MR", flag: "🇲🇷" },
    { label: "🇲🇺 Mauritius", value: "Mauritius", code: "MU", flag: "🇲🇺" },
    { label: "🇲🇽 Mexico", value: "Mexico", code: "MX", flag: "🇲🇽" },
    { label: "🇫🇲 Micronesia", value: "Micronesia", code: "FM", flag: "🇫🇲" },
    { label: "🇲🇩 Moldova", value: "Moldova", code: "MD", flag: "🇲🇩" },
    { label: "🇲🇨 Monaco", value: "Monaco", code: "MC", flag: "🇲🇨" },
    { label: "🇲🇳 Mongolia", value: "Mongolia", code: "MN", flag: "🇲🇳" },
    { label: "🇲🇪 Montenegro", value: "Montenegro", code: "ME", flag: "🇲🇪" },
    { label: "🇲🇦 Morocco", value: "Morocco", code: "MA", flag: "🇲🇦" },
    { label: "🇲🇿 Mozambique", value: "Mozambique", code: "MZ", flag: "🇲🇿" },
    { label: "🇲🇲 Myanmar", value: "Myanmar", code: "MM", flag: "🇲🇲" },
    { label: "🇳🇦 Namibia", value: "Namibia", code: "NA", flag: "🇳🇦" },
    { label: "🇳🇷 Nauru", value: "Nauru", code: "NR", flag: "🇳🇷" },
    { label: "🇳🇵 Nepal", value: "Nepal", code: "NP", flag: "🇳🇵" },
    { label: "🇳🇱 Netherlands", value: "Netherlands", code: "NL", flag: "🇳🇱" },
    { label: "🇳🇿 New Zealand", value: "New Zealand", code: "NZ", flag: "🇳🇿" },
    { label: "🇳🇮 Nicaragua", value: "Nicaragua", code: "NI", flag: "🇳🇮" },
    { label: "🇳🇪 Niger", value: "Niger", code: "NE", flag: "🇳🇪" },
    { label: "🇳🇬 Nigeria", value: "Nigeria", code: "NG", flag: "🇳🇬" },
    { label: "🇳🇺 Niue", value: "Niue", code: "NU", flag: "🇳🇺" },
    { label: "🇳🇴 Norway", value: "Norway", code: "NO", flag: "🇳🇴" },
    { label: "🇴🇲 Oman", value: "Oman", code: "OM", flag: "🇴🇲" },
    { label: "🇵🇰 Pakistan", value: "Pakistan", code: "PK", flag: "🇵🇰" },
    { label: "🇵🇼 Palau", value: "Palau", code: "PW", flag: "🇵🇼" },
    { label: "🇵🇦 Panama", value: "Panama", code: "PA", flag: "🇵🇦" },
    { label: "🇵🇬 Papua New Guinea", value: "Papua New Guinea", code: "PG", flag: "🇵🇬" },
    { label: "🇵🇾 Paraguay", value: "Paraguay", code: "PY", flag: "🇵🇾" },
    { label: "🇵🇪 Peru", value: "Peru", code: "PE", flag: "🇵🇪" },
    { label: "🇵🇭 Philippines", value: "Philippines", code: "PH", flag: "🇵🇭" },
    { label: "🇵🇱 Poland", value: "Poland", code: "PL", flag: "🇵🇱" },
    { label: "🇵🇹 Portugal", value: "Portugal", code: "PT", flag: "🇵🇹" },
    { label: "🇶🇦 Qatar", value: "Qatar", code: "QA", flag: "🇶🇦" },
    { label: "🇷🇴 Romania", value: "Romania", code: "RO", flag: "🇷🇴" },
    { label: "🇷🇺 Russia", value: "Russia", code: "RU", flag: "🇷🇺" },
    { label: "🇷🇼 Rwanda", value: "Rwanda", code: "RW", flag: "🇷🇼" },
    { label: "🇰🇳 Saint Kitts and Nevis", value: "Saint Kitts and Nevis", code: "KN", flag: "🇰🇳" },
    { label: "🇱🇨 Saint Lucia", value: "Saint Lucia", code: "LC", flag: "🇱🇨" },
    { label: "🇻🇨 Saint Vincent and the Grenadines", value: "Saint Vincent and the Grenadines", code: "VC", flag: "🇻🇨" },
    { label: "🇼🇸 Samoa", value: "Samoa", code: "WS", flag: "🇼🇸" },
    { label: "🇸🇲 San Marino", value: "San Marino", code: "SM", flag: "🇸🇲" },
    { label: "🇸🇹 Sao Tome and Principe", value: "Sao Tome and Principe", code: "ST", flag: "🇸🇹" },
    { label: "🇸🇦 Saudi Arabia", value: "Saudi Arabia", code: "SA", flag: "🇸🇦" },
    { label: "🇸🇳 Senegal", value: "Senegal", code: "SN", flag: "🇸🇳" },
    { label: "🇷🇸 Serbia", value: "Serbia", code: "RS", flag: "🇷🇸" },
    { label: "🇸🇨 Seychelles", value: "Seychelles", code: "SC", flag: "🇸🇨" },
    { label: "🇸🇱 Sierra Leone", value: "Sierra Leone", code: "SL", flag: "🇸🇱" },
    { label: "🇸🇬 Singapore", value: "Singapore", code: "SG", flag: "🇸🇬" },
    { label: "🇸🇰 Slovakia", value: "Slovakia", code: "SK", flag: "🇸🇰" },
    { label: "🇸🇮 Slovenia", value: "Slovenia", code: "SI", flag: "🇸🇮" },
    { label: "🇸🇧 Solomon Islands", value: "Solomon Islands", code: "SB", flag: "🇸🇧" },
    { label: "🇸🇴 Somalia", value: "Somalia", code: "SO", flag: "🇸🇴" },
    { label: "🇿🇦 South Africa", value: "South Africa", code: "ZA", flag: "🇿🇦" },
    { label: "🇬🇸 South Georgia and the South Sandwich Islands", value: "South Georgia and the South Sandwich Islands", code: "GS", flag: "🇬🇸" },
    { label: "🇸🇸 South Sudan", value: "South Sudan", code: "SS", flag: "🇸🇸" },
    { label: "🇪🇸 Spain", value: "Spain", code: "ES", flag: "🇪🇸" },
    { label: "🇱🇰 Sri Lanka", value: "Sri Lanka", code: "LK", flag: "🇱🇰" },
    { label: "🇸🇩 Sudan", value: "Sudan", code: "SD", flag: "🇸🇩" },
    { label: "🇸🇷 Suriname", value: "Suriname", code: "SR", flag: "🇸🇷" },
    { label: "🇸🇪 Sweden", value: "Sweden", code: "SE", flag: "🇸🇪" },
    { label: "🇨🇭 Switzerland", value: "Switzerland", code: "CH", flag: "🇨🇭" },
    { label: "🇸🇾 Syria", value: "Syria", code: "SY", flag: "🇸🇾" },
    { label: "🇹🇼 Taiwan", value: "Taiwan", code: "TW", flag: "🇹🇼" },
    { label: "🇹🇯 Tajikistan", value: "Tajikistan", code: "TJ", flag: "🇹🇯" },
    { label: "🇹🇿 Tanzania", value: "Tanzania", code: "TZ", flag: "🇹🇿" },
    { label: "🇹🇭 Thailand", value: "Thailand", code: "TH", flag: "🇹🇭" },
    { label: "🇹🇱 Timor-Leste", value: "Timor-Leste", code: "TL", flag: "🇹🇱" },
    { label: "🇹🇬 Togo", value: "Togo", code: "TG", flag: "🇹🇬" },
    { label: "🇹🇴 Tonga", value: "Tonga", code: "TO", flag: "🇹🇴" },
    { label: "🇹🇹 Trinidad and Tobago", value: "Trinidad and Tobago", code: "TT", flag: "🇹🇹" },
    { label: "🇹🇳 Tunisia", value: "Tunisia", code: "TN", flag: "🇹🇳" },
    { label: "🇹🇷 Turkey", value: "Turkey", code: "TR", flag: "🇹🇷" },
    { label: "🇹🇲 Turkmenistan", value: "Turkmenistan", code: "TM", flag: "🇹🇲" },
    { label: "🇹🇻 Tuvalu", value: "Tuvalu", code: "TV", flag: "🇹🇻" },
    { label: "🇺🇬 Uganda", value: "Uganda", code: "UG", flag: "🇺🇬" },
    { label: "🇺🇦 Ukraine", value: "Ukraine", code: "UA", flag: "🇺🇦" },
    { label: "🇦🇪 United Arab Emirates", value: "United Arab Emirates", code: "AE", flag: "🇦🇪" },
    { label: "🇬🇧 United Kingdom", value: "United Kingdom", code: "GB", flag: "🇬🇧" },
    { label: "🇺🇸 United States", value: "United States", code: "US", flag: "🇺🇸" },
    { label: "🇺🇾 Uruguay", value: "Uruguay", code: "UY", flag: "🇺🇾" },
    { label: "🇺🇿 Uzbekistan", value: "Uzbekistan", code: "UZ", flag: "🇺🇿" },
    { label: "🇻🇺 Vanuatu", value: "Vanuatu", code: "VU", flag: "🇻🇺" },
    { label: "🇻🇦 Vatican City", value: "Vatican City", code: "VA", flag: "🇻🇦" },
    { label: "🇻🇪 Venezuela", value: "Venezuela", code: "VE", flag: "🇻🇪" },
    { label: "🇻🇳 Vietnam", value: "Vietnam", code: "VN", flag: "🇻🇳" },
    { label: "🇾🇪 Yemen", value: "Yemen", code: "YE", flag: "🇾🇪" },
    { label: "🇿🇲 Zambia", value: "Zambia", code: "ZM", flag: "🇿🇲" },
    { label: "🇿🇼 Zimbabwe", value: "Zimbabwe", code: "ZW", flag: "🇿🇼" }
];

export default countryOptions;